import { useBlockProps } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const { title, link, link_email, assembly, assembly_id } = attributes;

	return (		
		<div { ...useBlockProps.save() }>
			<div>{title}</div>
			<div>{link}</div>
			<div>{link_email}</div>
			<div>{assembly}</div>
			<div>{assembly_id}</div>
		</div>
	);
}